/**
 * Categoría a mostrar para un tema (la primera de sus áreas, o "General").
 *
 * El color no se decide aquí: el Design Kit (§04) pinta las áreas y categorías
 * con una etiqueta neutra. Usa `<Etiqueta>` para renderizarla.
 */
export const categoriaDe = (t: { categoria: string | null }) => t.categoria || "General";

/**
 * Tipos de trabajo que admite un tema, como etiquetas legibles para los chips.
 * Son etiquetas neutras (el kit no les asigna color propio).
 */
export const tiposDeTema = (t: { is_memoria?: boolean; is_practica?: boolean; is_doble_titulacion?: boolean }): string[] => {
  const tipos: string[] = [];
  if (t.is_memoria) tipos.push("Memoria");
  if (t.is_practica) tipos.push("Práctica de título");
  if (t.is_doble_titulacion) tipos.push("Doble titulación");
  return tipos;
};

/**
 * Coguía a mostrar: etiqueta y valor. Si es externo, la etiqueta dice
 * "Coguía (externo)" y el valor incluye su correo entre paréntesis. Devuelve
 * `null` cuando el tema no tiene coguía.
 */
export const coguiaDe = (t: {
  coguia: string | null;
  coguia_es_externo?: boolean;
  coguia_email?: string | null;
}): { label: string; value: string } | null => {
  if (!t.coguia) return null;
  if (t.coguia_es_externo) {
    return { label: "Coguía (externo)", value: t.coguia_email ? `${t.coguia} (${t.coguia_email})` : t.coguia };
  }
  return { label: "Coguía", value: t.coguia };
};
